import { Adjustment } from './adjustment.model';
import { Txn } from './txn.model';
import { Funding } from './funding.model';

export class FundingResponse {
  public fundingdate: string;
  public merchid: string;
  public datechanged: string;
  public fundingmasterid: string;
  public fundings: Array<Funding>;
  public txns: Array<Txn>;
  public adjustments: Array<Adjustment>;
  public constructor() {
    this.fundingdate = '';
    this.merchid = '';
    this.datechanged = '';
    this.fundingmasterid = '';

    this.fundings = new Array<Funding>();
    this.txns = new Array<Txn>();
    this.adjustments = new Array<Adjustment>();
  }
}
